import { cn } from 'lib/utils';
import React from 'react';
import Text from '../Text';
import { fontSizes } from 'appconstants';

const SectionCard = ({ title = '', children, className }: { title?: string; children: React.ReactNode; className?: string }) => {
  return (
    <div className={cn('rounded-xl border bg-white px-5 pt-4 pb-1 shadow-md', className)}>
      {title && <Text text={title} className='font-bold mb-2' size={fontSizes.h18} />}
      <div>{children}</div>
    </div>
  );
};

export default SectionCard;
